import { gql, TypedDocumentNode } from '@apollo/client';

import { KmlLayer } from '@atom/types/map';

export const GET_KML_LAYERS: TypedDocumentNode<{
  kmlLayers: KmlLayer[];
}> = gql`
  query kmlLayers {
    kmlLayers {
      id
      name
      markerId
      url
      pollingInterval
      suppressInfoWindows
      extendedData {
        type
        key
        name
      }
      client
    }
  }
`;
